<template>
    <div ref="container" class="container p-0 m-0 position-fixed col-12">
        <ModalComponent
            v-if="choseNumber"
            show
            :title="t('new-general.board-number')"
            :classList="['col-12 col-md-6 col-lg-4 col-x-lg-3']"
            @hide="() => (choseNumber = null)"
        >
            <form @submit.prevent="() => add(choseNumber)">
                <div class="row p-3 m-0" style="gap: 14px">
                    <input
                        type="number"
                        required
                        v-model="choseNumber.number"
                        :min="0"
                        :max="100"
                        class="form-control"
                        style="flex: 1 !important"
                        :placeholder="t('new-general.board-number')"
                    />
                    <button class="btn btn-primary">
                        <i class="fa fa-check"></i>
                    </button>
                </div>
                <!-- Btns -->
                <div
                    class="tools row flex-wrap m-0 justify-content-center align-items-center px-0 py-2"
                    style="gap: 10px"
                >
                    <div
                        v-for="i in 11"
                        :key="i"
                        role="button"
                        style="width: 45px; height: 45px"
                        class="position-relative"
                        @click="
                            () => {
                                choseNumber.number = i;
                                add(choseNumber);
                                choseNumber = null;
                            }
                        "
                    >
                        <div
                            class="button-div"
                            :style="{
                                'background-color': choseNumber.background,
                                color: choseNumber.color,
                            }"
                        >
                            {{ i }}
                        </div>
                    </div>
                </div>
            </form>
        </ModalComponent>

        <ModalComponent
            v-if="choseItem && esporte"
            show
            :classList="['col-12 col-md-6']"
            @hide="() => (choseItem = false)"
        >
            <IconsComponent
                :items="items"
                @click="
                    (image) => {
                        addIcon(image);
                        choseItem = false;
                    }
                "
            />
        </ModalComponent>

        <div class="position-relative d-flex col-12 draw-container">
            <img
                :src="bg"
                class="background"
                :class="{
                    horizontal: size.h < size.w,
                    vertical: size.h >= size.w,
                }"
            />
            <div
                class="d-flex p-1 m-0 flex-column position-absolute"
                style="right: 1rem"
            ></div>

            <canvas id="canvas" ref="canvas" tabindex="1">
                Canvas not suported
            </canvas>

            <button
                class="btn btn-primary hide-tools position-absolute"
                @click="
                    () => {
                        showTools = !showTools;
                        line.modal = false;
                    }
                "
            >
                <i
                    class="fa fa-angle-down"
                    :style="{
                        transform: showTools
                            ? `rotate(180deg)`
                            : 'rotate(0deg)',
                    }"
                ></i>
            </button>
            <div
                class="p-1 m-0 flex-column position-absolute tools"
                :class="{ 'd-none': !showTools, 'd-flex': showTools }"
                style="left: 1rem; top: 0px"
            >
                <button class="btn btn-danger mx-2" @click="clear">
                    <i class="fa fa-eraser"></i>
                </button>
                <button
                    class="btn btn-warning mx-1"
                    :class="{ 'btn-secondary disabled': !canUndo }"
                    @click="() => undo()"
                >
                    <i class="fa fa-undo"></i>
                </button>
                <button
                    class="btn btn-warning mx-1"
                    :class="{ 'btn-secondary disabled': !canRedo }"
                    @click="() => redo()"
                >
                    <i class="fa fa-redo"></i>
                </button>
                <button
                    class="btn btn-outline-primary mx-1"
                    @click="
                        () => {
                            scale(false);
                        }
                    "
                >
                    <i class="fa fa-minus"></i>
                </button>
                <button
                    class="btn btn-outline-primary mx-1"
                    @click="
                        () => {
                            scale(true);
                        }
                    "
                >
                    <i class="fa fa-plus"></i>
                </button>
                <button
                    class="btn btn-danger mx-1"
                    @click="() => removeArrows()"
                >
                    <i class="fa fa-close"></i>
                    <i class="fa fa-arrow-right"></i>
                </button>
            </div>
            <div
                class="p-1 m-0 flex-column position-absolute tools"
                :class="{ 'd-none': !showTools, 'd-flex': showTools }"
                style="right: 1rem; top: 0px"
            >
                <div
                    role="button"
                    style="width: 45px; height: 45px"
                    class="position-relative"
                >
                    <div
                        class="button-div position-absolute"
                        :data-obj="obj1"
                        :style="{
                            'background-color': obj1.background,
                            color: obj1.color,
                        }"
                        @click="() => (choseNumber = obj1)"
                    >
                        {{ obj1.number }}
                    </div>
                    <InputColor
                        v-model:pure-color="obj1.background"
                        ref="colorInput"
                        class="position-absolute button-icon text-light p-1"
                    />
                    <InputColor
                        v-model:pure-color="obj1.color"
                        ref="colorInput2"
                        class="left-0 start-0 bottom'0 position-absolute button-icon text-light p-1"
                    />
                </div>
                <div
                    role="button"
                    style="width: 45px; height: 45px"
                    class="position-relative"
                >
                    <div
                        class="button-div position-absolute"
                        :style="{
                            'background-color': obj2.background,
                            color: obj2.color,
                        }"
                        @click="() => (choseNumber = obj2)"
                    >
                        {{ obj2.number }}
                    </div>
                    <InputColor
                        v-model:pure-color="obj2.background"
                        ref="colorInput"
                        class="position-absolute button-icon text-light p-1"
                    />
                    <InputColor
                        v-model:pure-color="obj2.color"
                        ref="colorInput2"
                        class="left-0 start-0 bottom'0 position-absolute button-icon text-light p-1"
                    />
                </div>

                <button
                    class="btn mx-1"
                    :class="{ 'btn-primary': line.drawing }"
                    @click="() => (line.drawing = !line.drawing)"
                >
                    <i v-if="line.mode == 'free'" class="fa fa-pencil"></i>
                    <img
                        v-if="line.mode == 'line'"
                        :src="lineIcon"
                        alt="line"
                        style="max-width: 4rem"
                    />
                    <img
                        v-if="line.mode == 'dash'"
                        :src="lineDash"
                        alt="dash"
                        style="max-width: 4rem"
                    />
                    <img
                        v-if="line.mode == 'arrow'"
                        :src="arrow"
                        alt="arrow"
                        style="max-width: 4rem"
                    />
                    <img
                        v-if="line.mode == 'adash'"
                        :src="arrwoDash"
                        alt="adash"
                        style="max-width: 4rem"
                    />
                </button>
                <div
                    style="width: auto"
                    class="position-relative dropdown p-0 m-0"
                >
                    <button
                        class="btn btn-outline-primary mx-1"
                        @click="line.modal = true"
                    >
                        <i class="fa fa-ellipsis-h"></i>
                    </button>
                    <div
                        class="position-fixed options-modal bg-white p-2"
                        :class="{ 'd-none': !line.modal }"
                    >
                        <i
                            class="fa fa-close p-1"
                            role="button"
                            @click="line.modal = false"
                        ></i>
                        <ul class="navbar-nav ml-auto">
                            <li
                                class="nav-item p-2"
                                role="button"
                                @click="() => changeMode('free')"
                            >
                                <i class="fa fa-pencil"></i>
                                {{ t("general.draw") }}
                            </li>
                            <li
                                class="nav-item p-2"
                                role="button"
                                @click="() => changeMode('line')"
                            >
                                <img :src="lineIcon" alt="line" />
                                {{ t("arrows.line") }}
                            </li>
                            <li
                                class="nav-item p-2"
                                role="button"
                                @click="() => changeMode('dash')"
                            >
                                <img :src="lineDash" alt="line-das" />
                                {{ t("arrows.dashed") }}
                            </li>
                            <li
                                class="nav-item p-2"
                                role="button"
                                @click="() => changeMode('arrow')"
                            >
                                <img :src="arrow" alt="arrow" />
                                {{ t("arrows.arrow") }}
                            </li>
                            <li
                                class="nav-item p-2"
                                role="button"
                                @click="() => changeMode('adash')"
                            >
                                <img :src="arrwoDash" alt="line" />
                                {{ t("arrows.dashed") }},
                                {{ t("arrows.arrow") }}
                            </li>
                        </ul>
                        <hr />
                        <div
                            class="row m-0 align-items-center"
                            style="gap: 10px"
                        >
                            <label for="linewidth"
                                >{{ t("arrows.width") }}:
                            </label>
                            <input
                                type="number"
                                style="flex: 1 !important"
                                :min="1"
                                :max="10"
                                v-model="line.width"
                            />
                        </div>
                        <hr />
                        <div
                            class="row m-0 align-items-center"
                            style="gap: 10px"
                        >
                            <label>{{ t("general.select_color") }}: </label>
                            <InputColor
                                v-model:pure-color="line.color"
                                style="flex: 1 !important; height: 1.4rem"
                            />
                        </div>
                    </div>
                </div>
                <button
                    class="btn btn-btn-outline-primary mx-1"
                    @click="() => (choseItem = true)"
                >
                    <i class="fa fa-circle"></i>
                </button>
                <div style="width: auto">
                    <button
                        class="btn btn-outline-primary mx-1 p-0 px-1"
                        @click="() => (chosing = true)"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            fill="#000000"
                            viewBox="0 0 256 256"
                        >
                            <path
                                d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,112h-8a32,32,0,0,1,0-64h8ZM32,96h8a32,32,0,0,1,0,64H32Zm0,80h8a48,48,0,0,0,0-96H32V64h88V192H32Zm192,16H136V64h88V80h-8a48,48,0,0,0,0,96h8v16Z"
                            ></path>
                        </svg>
                    </button>
                </div>
                <button class="btn btn-danger mx-1" @click="close">
                    <i class="fa fa-home"></i>
                </button>
            </div>
        </div>

        <div
            v-if="!alertCancel && size.h > size.w"
            class="alert position-absolute col-12 text-center row m-0 p-1 justify-content-center align-items-center"
        >
            <div>
                {{ t("new-general.board-alert") }}
                <br />
                <button
                    class="btn btn-primary my-4"
                    @click="() => (alertCancel = true)"
                >
                    {{ t("new-general.board-alert-ignore") }}
                </button>
            </div>
        </div>
        <template v-if="esporte && chosing">
            <SelectCampoComponent
                @hide="onCloseCamps"
                @select="onSelect"
                id="selectcamp"
                show
                :esporte="esporte"
            />
        </template>
    </div>
</template>
<script setup>
import { onBeforeUnmount, onMounted, reactive, ref, watch } from "vue";
import { getAngle, initMinifiedCanvas } from "../utilities/DrawFunctions.js";
import SelectCampoComponent from "../components/SelectCampoComponent.vue";
import { useHead } from "@vueuse/head";
import InputColor from "@/components/InputColor.vue";
import { fabric } from "fabric";
import { useRoute, useRouter } from "vue-router";
import Api from "../utilities/Api.js";
import { t } from "@/lang/index.js";
import { createHistory } from "../utilities/fabricjs-history.js";
import lineDash from "../assets/icons/line-dash.png";
import lineIcon from "../assets/icons/line.png";
import arrwoDash from "../assets/icons/arrow-dash.png";
import arrow from "../assets/icons/arrow.png";
import { useStore } from "vuex";
import { v4 } from "uuid";
import ModalComponent from "@/components/AdminLTE/Components/ModalComponent.vue";
import IconsComponent from "@/components/marcar/IconsComponent.vue";

useHead({
    meta: [
        {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0",
        },
    ],
});

const size = reactive({
    w: window.innerWidth,
    h: window.innerHeight,
});

const showTools = ref(true);
const choseItem = ref(false);
const route = useRoute();
const router = useRouter();
const canUndo = ref(false);
const esporte = ref(null);
const canRedo = ref(false);
const store = useStore();
const chosing = ref(true);
const alertCancel = ref(false);
const bg = ref(null);
const choseNumber = ref(null);
const items = [];

const obj1 = reactive({
    background: "#512da7",
    number: 1,
    color: "#ffffff",
    auto: false,
    scale: 0.5,
    key: "object1",
});
const obj2 = reactive({
    background: "#a81532",
    number: 1,
    color: "#ffffff",
    auto: false,
    scale: 0.5,
    key: "object2",
});

const line = reactive({
    mode: "free",
    width: 5,
    color: "#fff0f0",
    modal: false,
    drawing: false,
});

const temp = ref(null);

const clear = () => {
    if (confirm(t("new-general.clear-board"))) {
        if (window.canvas) {
            window.canvas.reset();
        }
    }
};
// Historico do canvas
const undo = (canvas = window.canvas) => {
    canvas.undo();
};

const redo = (canvas = window.canvas) => {
    canvas.redo();
};

const close = () => {
    if (confirm(t("profile.exit") + "?")) {
        router.push("/");
    }
};

const removeArrows = (canvas = window.canvas) => {
    canvas.forEachObject((obj) => {
        if (!obj.teamKey) {
            canvas.remove(obj);
        }
    });
};

const add = (o) => {
    line.drawing = false;
    // Criar círculo
    const circle = new fabric.Circle({
        radius: 30, // raio do círculo
        fill: o.background, // cor de fundo
        originX: "center", // centro horizontal
        originY: "center", // centro vertical
    });

    // Criar texto (número)
    const text = new fabric.Textbox(String(o.number), {
        fontSize: 40,
        fill: o.color,
        textAlign: "center",
        fontFamily: "Impact",
        originX: "center",
        originY: "center",
        textBaseline: "alphabetic",
    });

    // Agrupar os dois
    const group = new fabric.Group([circle, text], {
        originX: "center",
        originY: "center",
        scalable: true,
        scaleX: o.scale,
        scaleY: o.scale,
        left: window.canvas.width / 2,
        top: window.canvas.height / 2,
        teamKey: o.key,
    });

    // Adicionar ao canvas
    window.canvas.add(group);
    window.canvas.requestRenderAll();
    window.canvas.record();
    if (o.auto) {
        o.number += 1;
    }

    choseNumber.value = null;
    return group;
};

const onMouseDown = (event, canvas) => {
    const pointer = canvas.getPointer(event.e);

    if (line.drawing && line.mode != "free") {
        const uuid = v4();
        // Criar a linha inicial
        const newLine = new fabric.Line(
            [pointer.x, pointer.y, pointer.x, pointer.y],
            {
                stroke: line.color || "black",
                strokeWidth: line.width || 5,
                uuid,
                selectable: false,
                evented: false,
                strokeDashArray: ["adash", "dash"].includes(line.mode)
                    ? [5, 5]
                    : null,
            },
        );

        canvas.add(newLine);

        // Criar a seta se necessário
        let arrow = null;
        if (["arrow", "adash"].includes(line.mode)) {
            arrow = new fabric.Triangle({
                left: pointer.x + line.width / 2,
                top: pointer.y + line.width / 2,
                originX: "center",
                originY: "center",
                width: line.width * 4,
                height: line.width * 4,
                fill: line.color || "black",
                selectable: false,
                evented: false,
                uuid,
            });
            canvas.add(arrow);
        }

        temp.value = { line: newLine, arrow: arrow };
    }
};

const onMouseMove = (event, canvas) => {
    if (!temp.value) return;
    const pointer = canvas.getPointer(event.e);

    // Atualizar posição da linha
    temp.value.line.set({ x2: pointer.x, y2: pointer.y });
    const { x1, y1, x2, y2 } = temp.value.line;

    // Atualizar a seta se existir
    if (temp.value.arrow) {
        temp.value.arrow.set({
            left: pointer.x + temp.value.line.strokeWidth / 2,
            top: pointer.y + temp.value.line.strokeWidth / 2,
            angle: getAngle(x1, y1, x2, y2),
        });
    }

    canvas.renderAll();
};

const onMouseUp = (event, canvas) => {
    line.drawing = false;
    if (temp.value) {
        const objects = [temp.value.line];
        if (temp.value.arrow) objects.push(temp.value.arrow);

        canvas.forEachObject((obj) => {
            if (obj.uuid && obj.uuid == objects[0].uuid) {
                canvas.remove(obj);
            }
        });

        const group = new fabric.Group(objects, {
            selectable: true,
            lockMovementX: true,
            lockMovementY: true,
        });

        // Adicionar grupo final
        canvas.add(group);

        temp.value = null;
    }

    if (canvas.getActiveObject()) {
        canvas.record();
    }
};

const init = () => {
    initMinifiedCanvas();

    createHistory({
        canvas: window.canvas,
        propertiesToInclude: ["teamKey"],
        maxlength: 100,
    });

    window.addEventListener("resize", onResize);
    window.canvas.on("mouse:down", (e) => onMouseDown(e, window.canvas));
    window.canvas.on("mouse:move", (e) => onMouseMove(e, window.canvas));
    window.canvas.on("mouse:up", (e) => onMouseUp(e, window.canvas));
    window.canvas.on("history:change", function (action) {
        canRedo.value =
            window.canvas._historyIndex < window.canvas._stack?.length - 1;
        canUndo.value = window.canvas._historyIndex > 0;
        if (action != "record") {
            window.canvas.forEachObject((obj) => {
                if (obj.teamKey == obj1.key || obj.teamKey == obj2.key) {
                    obj.set("scaleX", obj1.scale);
                    obj.set("scaleY", obj1.scale);
                }
            });
            window.canvas.requestRenderAll();
        }
    });
};

const onSelect = (url) => {
    bg.value = `${Api.url}elements?path=${url}`;
    chosing.value = false;
};

const onCloseCamps = () => {
    if (bg.value) {
        chosing.value = false;
    } else {
        router.back();
    }
};

const changeMode = (mode) => {
    line.mode = mode;
    line.drawing = true;
    line.modal = false;
};

const scale = (up = true) => {
    if (up) {
        obj1.scale += 0.01;
        obj2.scale += 0.01;
    } else if (obj1.scale > 0.02) {
        obj1.scale -= 0.01;
        obj2.scale -= 0.01;
    }
    window.canvas.forEachObject((obj) => {
        if (obj.teamKey == obj1.key || obj.teamKey == obj2.key) {
            obj.set("scaleX", obj1.scale);
            obj.set("scaleY", obj1.scale);
        }
    });

    window.canvas.requestRenderAll();
};

const addIcon = (image) => {
    const tempImage = new Image();
    tempImage.crossOrigin = "anonymous"; // Permite carregamento seguro
    tempImage.src = image.src;

    tempImage.onload = () => {
        // Converter a imagem para Base64
        const tempCanvas = document.createElement("canvas");
        const tempCtx = tempCanvas.getContext("2d");
        tempCanvas.width = tempImage.width;
        tempCanvas.height = tempImage.height;
        tempCtx.drawImage(tempImage, 0, 0);

        const base64Image = tempCanvas.toDataURL("image/png");

        fabric.Image.fromURL(
            base64Image,
            function (fabricImg) {
                fabricImg.set({
                    originX: "center",
                    originY: "center",
                    scalable: true,
                    left: window.canvas.width / 2,
                    top: window.canvas.height / 2,
                    teamKey: "items",
                });
                window.canvas.add(fabricImg);
            },
            {},
        );
    };
};
const onResize = () => {
    size.h = window.innerHeight;
    size.w = window.innerWidth;
    window.canvas.setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    window.canvas.requestRenderAll(); // Redraw canvas after resizing
};

onMounted(async () => {
    store.commit("SET_LOADING", true);
    for (let i = 1; i <= 19; i++) {
        items.push(`icons/${i}.png`);
    }
    try {
        const res = await Api.get(`sports/${route.query.esporte}`);
        esporte.value = res.data;
        console.log(esporte.value);
        store.commit("SET_LOADING", false);
        init();
    } catch (e) {
        console.log(e);
        alert("error");
    }
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", onResize);
    useHead({
        meta: [{ name: "viewport", content: "" }],
        tagDuplicateStrategy: "replace",
    });
});

watch(
    () => [line.drawing, line.color, line.width, line.mode],
    ([drawing, color, width, mode]) => {
        window.canvas.isDrawingMode = drawing && mode == "free";
        window.canvas.freeDrawingBrush.color = color; // cor do traço
        window.canvas.freeDrawingBrush.width = width;

        window.canvas.forEachObject((obj) => {
            obj.selectable = !drawing;
            obj.evented = !drawing;
        });
    },
);

watch(
    () => [showTools.value],
    ([show]) => {
        window.canvas.forEachObject((obj) => {
            obj.setControlsVisibility({
                tl: false,
                tr: false,
                bl: show, // mantém só o bottom-left
                br: false,
                ml: false,
                mt: false,
                mr: false,
                mb: false,
                deleteControl: show,
                mtr: false,
            });
        });
        window.canvas.requestRenderAll();
    },
);
</script>

<style lang="scss" scoped>
.container {
    * {
        transition: 0.23s ease-in-out;
    }
    z-index: 1040;
    top: 0;
    background-color: white;
    left: 0;

    .alert {
        background-color: rgba(200, 200, 200, 0.94);
        font-weight: bold;
        font-size: 1.4rem;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 5;
    }
    .background {
        object-fit: contain;
        position: absolute;
        z-index: 0;
        height: auto;
        margin: auto;
        left: 0px;
        right: 0px;
        max-height: 100vh !important;
        width: 100vw;
    }
    #canvas {
        background-color: transparent;
    }

    .hide-tools {
        bottom: 0.5rem;
        border-radius: 50px !important;
        width: 50px;
        height: 50px;
        z-index: 5;
        left: 0.5rem;
    }
    .draw-container {
        .tools {
            bottom: 0.5rem;
            background-color: rgba(255, 255, 255, 0.8);
            align-items: center;
            justify-content: center;
            height: 100vh;
        }
    }
    .tools {
        gap: 10px;
        z-index: 3;
        .button-div {
            top: 0px !important;
            width: 100%;
            text-align: center;
            line-height: 45px;
            height: 45px;
            font-weight: bold;
            font-family: Calibri;
            font-size: 1.3rem;
            border-radius: 100%;
            border: 2.3px solid black;
        }

        .button-icon {
            top: 0px;
            right: 0px;
            border-radius: 100%;
            border: 2.3px solid black;
            padding: 0px !important;
            width: 1rem;
            height: 1rem;
        }

        .dropdown {
            .options-modal {
                bottom: 0px;
                right: 0px;
                width: auto !important;

                .nav-item {
                    width: auto !important;
                    white-space: nowrap;
                    img {
                        max-height: 1rem;
                        object-fit: contain;
                        max-width: 6rem;
                    }
                }
                .nav-item:hover {
                    background-color: rgba(20, 20, 20, 0.4);
                }
            }
        }
    }
}
</style>
